import React from "react";
import NavbarMain from "./NavbarMain";
import Footer from "./Footer";
import LearnMoreContent from "./LearnMoreContent";
import { useMediaQuery } from "react-responsive";
import NavbarMainMobile from "./NavbarMainMobile";
import LearnMoreContentMobile from "./LearnMoreContentMobile";

const LearnMore = () => {
  const activeCategory = "Learnmore";
  const activeCategoryMobile = "learnmore";
  const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  return (
    <div>
      {isMobile ? (
        <>
          {" "}
          <NavbarMainMobile activeCategoryMobile={activeCategoryMobile} />
          <LearnMoreContentMobile />
        </>
      ) : (
        <>
          <NavbarMain activeCategory={activeCategory} />
          <LearnMoreContent />
          <Footer />
        </>
      )}
    </div>
  );
};

export default LearnMore;
